import type { SearchParams } from '@@/types/ClientsRepository';
import type { Client, SisProvider, Subscription } from '@@/types/Clients';
import type { JsonBodyRequest } from './jsonapi';
import { kebabCaseKeys } from '../../../utils/object';

export interface ASSearchParams {
  include?: string;
  'page[number]'?: number;
  'page[size]'?: number;
  'filter[name]'?: string;
  'filter[country]'?: string;
  'filter[state]'?: string;
  sort?: string;
}

export interface JSONApiClient {
  name: string;
  'display-name'?: string;
  'sales-id': string;
  'apptegy-id': string;
  'media-subdomain'?: string;
  'phone-number': string;
  email: string;
  address: string;
  zip: string;
  state: string;
  city: string | null;
  'time-zone': string;
  'fax-number': string;
  'admin-name': string;
  'admin-first-name': string | null;
  'admin-last-name': string | null;
  'admin-phone-number': string;
  'admin-email': string;
  //TODO: review this type I think it is better represented as a string
  // settings: {
  //   classes: boolean;
  //   features: any[];
  //   corporate: boolean;
  //   languages: any[];
  //   time_zone: string;
  //   domain_names: any[];
  //   flagged_messages_for_roles: {
  //     staff: boolean;
  //     student: boolean;
  //     guardian: boolean;
  //   };
  //   infolink_enabled: boolean;
  //   rooms_enabled: boolean;
  //   media_enabled: boolean;
  //   inbox_enabled: boolean;
  //   navigate_enabled: boolean;
  //   flagged_messages: boolean;
  //   enabled_behavior: boolean;
  //   enable_mfa_for_student: boolean;
  //   enable_mfa_for_staff: boolean;
  //   enable_mfa_for_guardian: boolean;
  //   chat_max_participants: number;
  //   engage: {
  //     audiences: boolean;
  //     brands: boolean;
  //     newsletters: boolean;
  //   };
  //   mobile_school_app: {
  //     rooms_first_screen: boolean;
  //     phone_primary_login: boolean;
  //   };
  //   forms_enabled: boolean;
  //   intranet_enabled: boolean;
  // };
  settings: string;
  notes?: {
    notes?: string;
  };
  'catholic-school': boolean;
  'school-district': boolean;
  pem: string | null;
  'private-organization': boolean;
  'public-organization': boolean;
  'charter-organization': boolean;
  'military-base-school': boolean;
  'international-client': boolean;
  municipality: boolean;
  'sis-provider'?: SisProvider | null;
  sku: string | null;
  'website-url': string;
  'ios-app-link': string;
  'android-app-link': string;
  country: string;
}

interface JSONApiSubscription {
  'client-id': number;
  'oauth-application-id': number;
  id: number;
  'mobile-enabled': boolean;
}

export function toAuthServiceSearchParams(params: SearchParams): ASSearchParams {
  return {
    include: params.include,
    'page[number]': params.pageNumber,
    'page[size]': params.pageSize,
    'filter[name]': params.filters?.name,
    'filter[country]': params.filters?.country,
    'filter[state]': params.filters?.state,
    sort: params.sort,
  };
}

export function clientPayload(client: Partial<Client>) {
  const { subscriptions: _, id: __, meta: ___, tasksAdminUser: ____, ...clientCopy } = client;
  if (clientCopy.notes) {
    clientCopy.notes = kebabCaseKeys(clientCopy.notes);
  }
  const payload: JsonBodyRequest<JSONApiClient> = {
    data: {
      attributes: kebabCaseKeys<JSONApiClient>(clientCopy),
      type: 'clients',
    },
  };
  if (client.id) {
    delete payload.data.attributes.name;
    payload.data.id = client.id;
  }
  return payload;
}
export function subscriptionsPayload(
  clientId,
  subscription: Partial<Subscription>,
): JsonBodyRequest<Partial<JSONApiSubscription>> {
  const { id, ...sub } = subscription;
  const attributes = kebabCaseKeys<Partial<JSONApiSubscription>>(sub);
  attributes['client-id'] = clientId;
  return {
    data: {
      attributes,
      type: 'subscriptions',
      id: id,
    },
  };
}
